import { createAsyncThunk } from '@reduxjs/toolkit';

import api, { AxiosError } from 'api';

export const getServiceProviders = createAsyncThunk(
    'GET/service_providers',
    async (providersIds: string[], { dispatch, rejectWithValue }) => {
        const requests = providersIds.map((id) => dispatch(loadServiceProvider(id)));

        try {
            return await Promise.allSettled(requests);
        } catch (e) {
            return rejectWithValue((e as AxiosError).response?.data);
        }
    }
);

export const loadServiceProvider = createAsyncThunk(
    'api/service_provider/{service_provider_id}',
    async (id: string) => await api.serviceProvider.get(id)
);
